import Vue from 'vue'
let el = new Vue();

/* 
成功   this.$http("")
错误   this.$http("","err")
信息   this.$http("","info")
警告   this.$http("","warning")
*/

export default (title,type="") => {
    let iconClass = "el-icon-success";
    switch(type) {
        case "err":
            iconClass = "el-icon-error"
        break;
        case "info":
            iconClass = ""
        break;
        case "warning":
            iconClass = "el-icon-warning"
        break;
    }
    el.$notify({
        title,
        duration: 2500,
        iconClass,
        customClass: "notification"
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/hint.js